<template>
	<div>
		<div class="container-fluid font-size-11 font-size-sm-10 pb-3">
			<div class="col-12 background-blue-light text-blue rounded pt-2 pb-2 d-flex" v-if="info">
				<div class="font-size-12 m-auto"><i class="fas fa-exclamation-circle"></i></div>
				<div class="font-size-10 pl-2"> Silakan melengkapi detail Alamat utama Mobile Counter Anda untuk data Pengiriman dan Verifikasi
					akun menjadi lebih lengkap. Pastikan Anda melengkapi data dengan benar.</div>
			</div>
			<form>
				<div class="row">
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-12 pt-3">
								<div class="mb-1">Provinsi</div>
								<select :disabled="!info" class="form-control font-size-10 box-purple" v-model="paramsAddress.province"
									@change="selectProv(paramsAddress.province)">
									<option disabled value="">Pilih Provinsi</option>
									<option v-for="(value, index) in province" :key="index"
										:value="{ id: value.province_id, text: value.province }">{{ value.province }}</option>
								</select>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.province_id">Provinsi {{
									konfirmResponse.province_id }} </div>
								<div class="invalid-feedback d-block m-0" v-else-if="konfirmResponse.province_name">Provinsi {{
									konfirmResponse.province_name }} </div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="mb-1 mt-3">Kota/Kabupaten</div>
								<select :disabled="!info" class="form-control font-size-10 box-purple" v-model="paramsAddress.city"
									@change="selectCity(paramsAddress.city)">
									<option disabled value="">Pilih Kota/Kabupaten</option>
									<option v-for="(value, index) in city" :key="index" :value="{ id: value.city_id, text: value.city_name }">
										{{ value.type }} {{ value.city_name }}</option>
								</select>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.city_id">Kota {{ konfirmResponse.city_id }}
								</div>
								<div class="invalid-feedback d-block m-0" v-else-if="konfirmResponse.city_name">Kota {{ konfirmResponse.city_name
								}} </div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="mb-1 mt-3">Kecamatan</div>
								<select :disabled="!info" class="form-control font-size-10 box-purple" v-model="paramsAddress.subdistrict"
									@change="selectSubdistrict">
									<option disabled value="">Pilih Kecamatan</option>
									<option v-for="(value, index) in subdistrict" :key="index"
										:value="{ id: value.subdistrict_id, text: value.subdistrict_name }">{{ value.subdistrict_name }}</option>
								</select>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.subdistrict_id">Kecamatan {{
									konfirmResponse.subdistrict_id }} </div>
								<div class="invalid-feedback d-block m-0" v-else-if="konfirmResponse.subdistrict_name">Kecamatan {{
									konfirmResponse.subdistrict_name }} </div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="mb-1 mt-3">Alamat Lengkap</div>
								<textarea :disabled="!info" class="form-control font-size-10 textarea box-purple" rows="3"
									placeholder="Masukkan Alamat Lengkap" v-model="paramsAddress.address"
									@blur="cekMaps()"></textarea>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.address">Alamat {{ konfirmResponse.address }}
								</div>
							</div>
						</div>
					</div>
					<input type="hidden" name="latitude" v-model="paramsAddress.lat">
					<input type="hidden" name="longitude" v-model="paramsAddress.lng">
					<div class="col-md-6 mt-4">
						<div v-if="map" style="width: 100%; height: 320px;">
							<l-map :zoom="zoom" :center="center" ref="myMap" class="resize-box">
								<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
								<l-marker v-if="position.lat !== 0 && position.lng !== 0 && this.info" :lat-lng="position" :draggable="draggable"
									@dragend="updateLocation" :z-index-offset="1000">
								</l-marker>
								<l-marker v-if="storeLocation.lat !== 0 && storeLocation.lng !== 0" :lat-lng="storePosition" :icon="customIcon">
								<l-tooltip :options="{ direction: 'bottom', offset: [0, -10] }">{{ userData.stockist_name }}</l-tooltip>
								</l-marker>
								<v-geosearch :options="geosearchOptions"></v-geosearch>
							</l-map>
						</div>
						<!-- <GmapMap :center="{
							lat: location.lat,
							lng: location.lng
						}" :zoom="16" :options="{
						zoomControl: false,
						mapTypeControl: false,
						scaleControl: false,
						streetViewControl: false,
						rotateControl: false,
						fullscreenControl: false,
						disableDefaultUi: true
					}" map-type-id="roadmap" style="width: 100%; height: 100%">
							<GmapMarker ref="myMarker" :draggable="!disabled" :position="{
								lat: location.lat,
								lng: location.lng
							}" @dragend="updateCoordinates" />
						</GmapMap> -->
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import VGeosearch from 'vue2-leaflet-geosearch';
import { mapActions, mapState } from 'vuex'
import { LMap, LMarker, LTileLayer, LTooltip } from 'vue2-leaflet';
import { latLng, icon } from 'leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import Vue from 'vue'
import { googleApiKey } from '@/config';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';

Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
	installComponents: true,
	load: {
		key: googleApiKey,
		libraries: 'places',
	}
})

export default {
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LTooltip,
		VGeosearch
	},
	data() {
		return {
			map: true,
			size: null,
			errors: {},
			provinsi: '',
			kota: '',
			kecamatan: '',
			alamat: '',
			storeLocation: {
				lat: 0,
				lng: 0,
			},
			// location: {
			// 	lat: 0,
			// 	lng: 0
			// },
			formLocation: {
				lat: '',
				lng: ''
			},

			url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
			attribution:
				'',
			zoom: 14,
			draggable: true,
			customIcon: icon({
				iconUrl: '/assets/icon/store-marker.png', // Path relative to your public directory
				iconSize: [50, 56], // size of the icon
				iconAnchor: [25, 56], // point of the icon which will correspond to marker's location
			}),
			geosearchOptions: {
				provider: new OpenStreetMapProvider(),
			}
		};
	},
	props: {
		info: Boolean,
		disabled: Boolean,
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('commonList', ['province', 'city', 'subdistrict', 'paramsAddress']),
		...mapState('maps', ['location']),
		...mapState('profileList', ['konfirmResponse']),
		center() {
			return latLng(this.location.lat, this.location.lng)
		},
		position() {
			return latLng(this.location.lat, this.location.lng)
		},
		storePosition() {
			return latLng(this.storeLocation.lat, this.storeLocation.lng)
		},
	},
	methods: {
		...mapActions('commonList', ['getProvince', 'getCity', 'getSubdistrict']),
		...mapActions('maps', ['postGeolocation', 'getMaps', 'getGeolocation']),

		async onResize() {
			await this.$refs.myMap.mapObject._onResize();
			// Access the Leaflet map instance
			const map = await this.$refs.myMap.mapObject;

			// Listen for the 'geosearch/showlocation' event on the map instance
			await map.on('geosearch/showlocation', this.handleGeosearchResult);
		},
		updateLocation(event) {
			const latLng = event.target.getLatLng();
			this.location.lat = latLng.lat;
			this.location.lng = latLng.lng;

			this.paramsAddress.lat = latLng.lat;
			this.paramsAddress.lng = latLng.lng;
		},
		handleGeosearchResult(event) {
			this.updateLocationSearch(event.location.y, event.location.x);
		},
		updateLocationSearch(lat, lng) {
			this.zoom = 16;
			this.location.lat = lat;
			this.location.lng = lng;

			this.paramsAddress.lat = lat;
			this.paramsAddress.lng = lng;
		},
		selectProv(prov) {
			this.paramsAddress.city = {}
			this.paramsAddress.subdistrict = {}
			this.konfirmResponse.province_id = ''
			this.konfirmResponse.province_name = ''
			this.getCity({
				province_id: prov.id
			})
		},
		selectCity(city) {
			this.paramsAddress.subdistrict = {}
			this.konfirmResponse.city_id = ''
			this.konfirmResponse.city_name = ''
			this.getSubdistrict({
				city_id: city.id
			})
		},
		selectSubdistrict() {
			this.konfirmResponse.subdistrict_id = ''
			this.konfirmResponse.subdistrict_name = ''
			this.cekMaps()
		},
		updateCoordinates(location) {
			this.postGeolocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		updateMaps() {
			// this.getMaps((address ? address + ', ' : '') + this.paramsAddress.subdistrict.text + ', ' + this.paramsAddress.city.text + ', ' + this.paramsAddress.province.text)
		},
		async cekMaps() {
			let district = this.subdistrict.find(el => el.subdistrict_id == this.paramsAddress.subdistrict.id)
			
			// this.getMaps((this.address ? this.address + ', ' : '') + district.subdistrict_name + ', ' + district.city_name + ', ' + district.province)
			let searchQuery = (this.paramsAddress.address ? this.paramsAddress.address + ', ' : '') + district.subdistrict_name + ', ' + district.city_name + ', ' + district.province
			const results = await this.geosearchOptions.provider.search({ query: searchQuery });
			if (results && results.length > 0) {
				this.updateLocationSearch(results[0].y, results[0].x);
			}
		},
	},
	async created() {
		this.getProvince()
		if (this.info) {
			await this.getGeolocation();
			let loc = JSON.parse(localStorage.getItem('loc'));
			this.location.lat = loc.lat;
			this.location.lng = loc.lng;
		} else {
			let loc = JSON.parse(localStorage.getItem('mobile-counter-pos-auth-data'));
			this.storeLocation.lat = parseFloat(loc.pos.stockist_latitude ? loc.pos.stockist_latitude : 0);
			this.storeLocation.lng = parseFloat(loc.pos.stockist_longitude ? loc.pos.stockist_longitude : 0);
		}
	},
	async mounted(){
		this.$nextTick(() => {
			this.onResize();
			window.addEventListener('resize', this.onResize);
		});
	}
};
</script>